import { jsx as e } from "react/jsx-runtime";
import o from "../../layout/flex-view.js";
const n = ({ width: t, height: r }) => /* @__PURE__ */ e(o, { $alignItems: "center", $justifyContent: "center", $width: t, $height: r, children: /* @__PURE__ */ e("div", { className: "app-loader", children: "Load ng" }) }), d = n;
export {
  d as default
};
//# sourceMappingURL=app-loader.js.map
